import * as React from "react";
import {useMediaQuery} from "beautiful-react-hooks";

import styles from "./CompactSearch.css";

interface CompactSearchProps {
    searchEndpointUri: string;
}

export const CompactSearch = (props: CompactSearchProps): JSX.Element => {
    const [inputs, setInputs] = React.useState({searchName: ""});
    const [isOpen, setIsOpen] = React.useState(false);
    const isMobile = useMediaQuery('(max-width: 650px)');

    const redirectToSearchPage = () => {
        const url = new URL(props.searchEndpointUri);

        url.searchParams.append("searchTerm", inputs.searchName);
        window.location.href = url.toString();

    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const name = event.target.name;
        const value = event.target.value;

        setInputs(values => ({...values, [name]: value}));
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();

        redirectToSearchPage();
    }

    const handleClick = (event: React.MouseEvent) => {
        if (!isOpen) {
            event.preventDefault();
        }

        isMobile && isOpen ? setIsOpen(false) : setIsOpen(true)
    }

    return (
        <div
        >
            <form
                onSubmit={handleSubmit}
                className={styles.searchForm}
            >
                <div className={styles.inputContainer}>
                    {isOpen
                        ? <>
                            <input
                                type="text"
                                name="searchName"
                                placeholder="Suche nach..."
                                value={inputs.searchName || ""}
                                onChange={handleChange}
                                className={styles.searchInput}
                            />
                            <span
                                className={styles.mobileGlass}
                                onClick={handleSubmit}
                            >
                                <GlassIcon color="#c9c9c9" />
                            </span>
                        </>
                        : null
                    }
                    <button
                        className={styles.submitBtn}
                        type="submit"
                        onClick={handleClick}
                        aria-label="Zur Suche"
                    >
                        <span className={styles.glass}>
                            <GlassIcon color="white" />
                        </span>
                    </button>
                </div>
            </form>
        </div>
    )
}
interface GlassIconProps {
    color: string
}
export const GlassIcon = (props: GlassIconProps): JSX.Element => (
    <svg fill="#3c434b" xmlns="http://www.w3.org/2000/svg" viewBox="68.13 373.93 89.77 69.87">
        <path
            d="m157.9 435.7-32.7-19.6c1-2.2 1.8-4.6 2.2-7.1 2.9-16.2-8-31.8-24.2-34.6-16.2-2.9-31.8 8-34.6 24.2-2.9 16.2 8 31.8 24.2 34.6 1.7.3 3.5.5 5.2.5 8.5 0 16.4-3.7 22-9.7l33.1 19.8 4.8-8.1Zm-63.5-11.8c-11.1-2-18.6-12.6-16.6-23.7s12.6-18.6 23.7-16.6 18.6 12.6 16.6 23.7-12.6 18.6-23.7 16.6Z"
        />
    </svg>
)

export const CloseIcon = (): JSX.Element => (
    <span className={styles.closeIcon}>
        &times;
    </span>
)
